<template>
  <div>
    <div class="hero-section">
      <div class="hero-content">
        <h1>欢迎来到天狗商城</h1>
        <p>精选全球好物，为您提供优质的购物体验</p>
        <template v-if="!isAdmin">
        <div class="hero-buttons">
          <router-link to="/products" class="btn btn-primary">浏览商品</router-link>
          <router-link to="/hot" class="btn btn-secondary">热门推荐</router-link>
        </div>
</template>
      </div>
    </div>
    <div class="page-container">
      <div class="services-section">
        <div class="service-item">
          <div class="icon">🚚</div>
          <h3>快速配送</h3>
          <p>全国大部分地区支持次日达</p>
        </div>
        <div class="service-item">
          <div class="icon">🛡️</div>
          <h3>品质保障</h3>
          <p>所有商品经过严格质检</p>
        </div>
        <div class="service-item">
          <div class="icon">💳</div>
          <h3>安全支付</h3>
          <p>支持多种支付方式，交易安全</p>
        </div>
        <div class="service-item">
          <div class="icon">🎧</div>
          <h3>贴心服务</h3>
          <p>7x24小时客服支持</p>
        </div>
      </div>
      
      <template v-if="!isAdmin">
        <h2 class="section-title">热门商品推荐</h2>
        <div v-if="products.length" class="product-grid">
          <router-link v-for="product in products" :key="product.id" :to="'/product/' + product.id" class="product-card-link">
            <div class="product-card">
              <div class="image-container">
                <img :src="product.imageUrl || 'https://placehold.co/400x300/EFEFEF/AAAAAA?text=无图片'" 
                     alt="商品图片" class="product-image">
                <div class="product-badge">热销</div>
              </div>
              <div class="product-info">
                  <h3>{{ product.name }}</h3>
                  <p class="product-description">{{ product.description || '暂无描述' }}</p>
                  <div class="price-and-action">
                    <p class="price">¥{{ product.price }}</p>
                    <span class="view-details-btn">查看详情 →</span>
                  </div>
              </div>
            </div>
          </router-link>
        </div>
        <p v-else class="loading-state">正在加载商品...</p>
      </template>

      <div v-else class="admin-welcome-panel">
        <h3>站长/管理员，您好！</h3>
        <p>欢迎来天狗商城后台管理系统。</p>
        <router-link to="/admin" class="admin-link-btn">进入管理后台</router-link>
      </div>

      </div>
  </div>
</template>

<script setup>
// [修改] 引入 computed 和 useStore
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import { useStore } from 'vuex';

// [修改] 获取 store 实例和 isAdmin 状态
const store = useStore();
const isAdmin = computed(() => store.getters.isAdmin);

const { appContext } = getCurrentInstance();
const $axios = appContext.config.globalProperties.$axios;

const products = ref([]);
const isLoading = ref(true); 

const fetchProducts = async () => {
  isLoading.value = true;
  try {
    const res = await $axios.get('/products');
    products.value = res.data.data.slice(0, 8);
  } catch (error) {
    console.error("获取商品列表失败:", error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(fetchProducts);
</script>

<style scoped>
.hero-section {
  text-align: center;
  padding: 120px 20px;
  background: linear-gradient(135deg, rgba(94, 114, 228, 0.9) 0%, rgba(72, 90, 193, 0.95) 100%), url('https://images.unsplash.com/photo-1555529669-e69e7aa0ba9e?auto=format&fit=crop&q=80');
  background-size: cover;
  background-position: center;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, transparent 0%, rgba(0, 0, 0, 0.3) 100%);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
}

.hero-content h1 { 
  font-size: 3.5em; 
  font-weight: 700;
  margin-bottom: 15px;
  text-shadow: 0 4px 15px rgba(0,0,0,0.2);
  animation: fadeInDown 1s ease;
}

.hero-content p { 
  font-size: 1.3em; 
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto 30px;
  text-shadow: 0 2px 10px rgba(0,0,0,0.2);
  animation: fadeInUp 1s ease 0.2s both;
}

.hero-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  animation: fadeInUp 1s ease 0.4s both;
}

.btn {
  display: inline-block;
  padding: 14px 32px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  font-size: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.services-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  background: #fff;
  padding: 40px;
  border-radius: 16px;
  margin-top: -60px;
  position: relative;
  box-shadow: 0 15px 40px rgba(0,0,0,0.1);
  margin-bottom: 40px;
  z-index: 10;
}

.service-item { 
  text-align: center;
  padding: 25px 20px;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.service-item:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: translateY(-8px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
  color: white;
}

.service-item:hover h3,
.service-item:hover p {
  color: white;
}

.service-item .icon { 
  font-size: 3em;
  line-height: 1;
  margin-bottom: 20px;
}

.service-item h3 { 
  margin: 15px 0 5px;
  font-weight: 600;
  color: #333;
  transition: color 0.3s;
}

.service-item p { 
  color: #888; 
  font-size: 0.9em; 
  line-height: 1.5;
  transition: color 0.3s;
}

.section-title {
  text-align: center;
  font-size: 2.2em;
  font-weight: 600;
  margin-top: 60px;
  margin-bottom: 40px;
  color: #2c3e50;
  position: relative;
  padding-bottom: 15px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #5e72e4, #9b59b6);
  border-radius: 3px;
}

.loading-state, .empty-state {
  text-align: center;
  padding: 60px;
  color: #888;
  font-size: 1.2em;
}

.spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #5e72e4;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.product-grid { 
  display: grid; 
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); 
  gap: 30px; 
  margin-bottom: 60px;
}

.product-card-link { 
  text-decoration: none; 
  color: inherit; 
}

.product-card {
  border-radius: 16px;
  background: #fff;
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.image-container {
  position: relative;
  overflow: hidden;
}

.product-image {
  width: 100%;
  height: 240px;
  object-fit: cover;
  background-color: #f5f5f5;
  transition: transform 0.35s ease;
}

.product-card:hover .product-image {
  transform: scale(1.05);
}

.product-badge {
  position: absolute;
  top: 15px;
  left: 15px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.8em;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.product-info {
  padding: 20px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.product-info h3 {
  font-size: 1.15em;
  margin: 0 0 10px 0;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
  flex-grow: 1;
}

.product-description {
  color: #7f8c8d;
  font-size: 0.9em;
  margin: 0 0 15px 0;
  line-height: 1.5;
  flex-grow: 1;
}

.price-and-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-top: 15px;
  border-top: 1px solid #f1f1f1;
}

.price {
  color: #e74c3c;
  font-weight: 700;
  font-size: 1.4em;
}

.view-details-btn {
  font-size: 14px;
  color: #888;
  font-weight: 500;
  transition: all 0.3s;
}

.product-card:hover .view-details-btn {
  color: #5e72e4;
  transform: translateX(5px);
}

/* [新增] 管理员欢迎面板的样式 */
.admin-welcome-panel {
  text-align: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 60px;
  border-radius: 16px;
  margin-top: 40px;
  box-shadow: 0 15px 40px rgba(0,0,0,0.1);
  color: white;
}

.admin-welcome-panel h3 {
  font-size: 2em;
  font-weight: 600;
  color: white;
  margin-bottom: 15px;
}

.admin-welcome-panel p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.1em;
  margin-top: 10px;
  margin-bottom: 25px;
}

.admin-link-btn {
  display: inline-block;
  margin-top: 25px;
  padding: 14px 32px;
  background-color: white;
  color: #667eea;
  text-decoration: none;
  border-radius: 30px;
  font-weight: 600;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.admin-link-btn:hover {
  background-color: rgba(255, 255, 255, 0.9);
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .services-section {
    grid-template-columns: repeat(2, 1fr);
    margin-top: -30px;
  }
  
  .hero-content h1 {
    font-size: 2.5em;
  }
  
  .hero-buttons {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .product-grid {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }
}

@media (max-width: 576px) {
  .services-section {
    grid-template-columns: 1fr;
    padding: 20px;
  }
  
  .hero-content {
    padding: 0 15px;
  }
}
</style>
